import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ExpedicionesContextService } from "../../../context/expediciones-context.service";
import { Message, SpinnerService } from "shared-components";
import { ExpedicionesService } from "../../../services/expediciones.service";

@Component({
  selector: "app-estado-certificado",
  templateUrl: "./estado-certificado.component.html",
})
export class EstadoCertificadoComponent implements OnInit {
  public estados;
  public mensajes = new Array<Message>();
  public showError: boolean;

  // Paginación
  public itemsPerPage = 10;
  public currentPage = 0;
  public totalItems: number;
  public readonly visiblePages = 3;

  // Ordenación
  public orderBy: string;
  public columnId: string;
  private _filters;

  public editedIndex = -1;

  public editForm!: FormGroup;

  @Input() certificadoId: number;

  constructor(
    private _translate: TranslateService,
    private _formBuilder: FormBuilder,
    private _spinnerService: SpinnerService,
    private _certificadosService: ExpedicionesService,
  ) {}

  ngOnInit(): void {
    this.editForm = this._formBuilder.group({
      observation: [""],
    });

    this.getEstadosCertificado();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public pushMessage(mensaje) {
    this.showError = true;
    if (mensaje.includes(".error.")) {
      this.mensajes.push({ class: "error", message: mensaje });
    } else {
      this.mensajes.push({ class: "success", message: mensaje });
    }
  }

  public getEstadosCertificado() {
    if (this._filters) {
      this._filters = this._filters;

      this._spinnerService.showSpinner();
      this._certificadosService
        .getEstadosCertificado(this._filters)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          this.estados = resp.lista;
          this.totalItems = resp.paginacionMeta.totalCount;
        });
    } else {
      this.applyFilters();
    }
  }

  private applyFilters() {
    this.currentPage = 0;
    this._filters = {
      id: this.certificadoId,
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage,
    };
    this.getEstadosCertificado();
  }

  public pageChange(page) {
    this._filters.numPagina = this.currentPage = page - 1;
    this.getEstadosCertificado();
  }

  public itemsPerPageChange(items) {
    this._filters.numPagina = this.currentPage = 0;
    this._filters.tamPagina = this.itemsPerPage = items;
    this.getEstadosCertificado();
  }

  public toOrderBy(columnFilter: string, colId: string) {
    this.columnId = colId;

    if (this.estados && this.estados.length > 0 && this._filters) {
      const isAscending = !this.orderBy || this.orderBy.includes("DESC");
      this.orderBy = isAscending ? "ASC" + colId : "DESC" + colId;
      this._filters.orderItems = [
        {
          orderProperty: columnFilter,
          orderByDescending: !isAscending,
        },
      ];

      this._spinnerService.showSpinner();
      this._certificadosService
        .getEstadosCertificado(this._filters)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          this.estados = resp.lista;
          this.totalItems = resp.paginacionMeta.totalCount;
        });
    }
  }

  public getIcon(prop: string, colId: string) {
    let iconClass = "fa fa-sort";
    if (
      this._filters &&
      this._filters.orderItems &&
      this._filters.orderItems[0].orderProperty.indexOf(prop) != -1 &&
      this.columnId === colId
    ) {
      iconClass =
        this._filters.orderItems[0].orderByDescending === true
          ? "fa fa-sort-down"
          : "fa fa-sort-up";
    }
    return iconClass;
  }

  /**
   * Para los iconos de los Certificados
   */
  public getCheckIconColor(estadoId: number) {
    switch (estadoId) {
      case 1: // Pendiente
        return { color: "#005ccc" };
      case 2: // Concedido
        return { color: "#2e9900" };
      case 3: // Retirado
        return { color: "#e61717" };
      case 4: // Cancelado
        return { color: "#cc7614" };
      case 5: // Expirado
        return { color: "#d4d4d4" };
    }
  }

  public getCheckIconTitle(estadoId: number) {
    switch (estadoId) {
      case 1:
        return this._translate.instant("global.tipoEstado.pending");
      case 2:
        return this._translate.instant("global.tipoEstado.valid");
      case 3:
        return this._translate.instant("global.tipoEstado.invalid");
      case 4:
        return this._translate.instant("global.tipoEstado.canceled");
      case 5:
        return this._translate.instant("global.tipoEstado.expired");
    }
  }

  public openObservationStatus(observation: string, index: number) {
    this.editForm.get("observation")?.setValue(observation);
    this.editedIndex = index;
  }

  public updateObservationStatus(certificadoExpedicionId: number) {
    const filters = {
      certificadoExpedicionEstadoHistId: certificadoExpedicionId,
      observaciones: this.editForm.get("observation")?.value,
    };

    this._certificadosService
      .updateCertificadoEstadoObservacion(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then(
        () => {
          this.editedIndex = -1;
          this.pushMessage("global.success.itemUpdated");
          this.getEstadosCertificado();
        },
        (error) => {
          this.pushMessage("global.error.noResponse");
        },
      );
  }

  public cancelUpdate() {
    this.editedIndex = -1;
  }
}
